import React from "react";
import Pagetitle from "../elements/Pagetitle";
import Timeline from "../elements/Timeline";

const educationData = [
  {
    id: 1,
    title: "BE in Software Engineering",
    subtitle: "Zhengzhou University",
    years: "2020 - Present",
    content:
      "I am currently pursuing my third year Bachelor of Engineering in Software Engineering. My expected graduation year is 2024.",
  },
];

const experienceData = [
  {
    id: 1,
    title: "Looking for Internship (Remote)",
    years: "Summer / Winter",
    content:
      "I'm exclusively looking for remote internship opportunities in the following areas: Python / Django, Backend developer, Data Science. I'm also comfortable with Java.",
  },
];

function Experiences() {
  return (
    <section id="experience">
      <div className="container">
        <Pagetitle title="Experience & Education" />
        <div className="row">
          
          <div className="col-md-6">
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
              <div className="timeline exp bg-white rounded shadow-dark padding-30 overflow-hidden">
                {experienceData.map((experience) => (
                  <Timeline key={experience.id} education={experience} />
                ))}
                <span className="line"></span>
              </div>
            </div>

          <div className="col-md-6">
            <div className="timeline edu bg-white rounded shadow-dark padding-30 overflow-hidden">
              {educationData.map((education) => (
                <Timeline key={education.id} education={education} />
              ))}
              <span className="line"></span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Experiences;
